// this directive makes the autofocus attribute work on inputs which are added
// dynamically through ngIf or the router.
//
// Source: https://stackoverflow.com/a/55005912
//
// Note: focus() will only open the keyboard on mobile devices if the context
//       is a "user context", e.g. click or mouse event. If the page is reloaded
//       or the context is a "script context" (e.g. timeout, http response), it
//       won't open the keyboard (this is a usability feature) and there seems to
//       be no way to force that from JS.
//
// Note: After some testing with actual mobile phones, I don't think any more that
//       mobile autofocus is a fundamentally good idea during checkout. So this is
//       only used in search right now.

import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[autofocus]',
    standalone: false
})

export class AutofocusDirective implements AfterViewInit {

    constructor(private el: ElementRef) {
    }

    ngAfterViewInit() {
        // Otherwise Angular throws error: Expression has changed after it was checked.
        window.setTimeout(() => {
            this.el.nativeElement.focus();
        });
    }
}
